import {parseQueryString} from '@daedalus/core/src/utils/url'

import history from './history'

export const getUrlParams = () => {
  return parseQueryString(history.location.search)
}
